module.exports = __webpack_public_path__ + "img/coffeeText.6008fbe5.png";